export default __webpack_public_path__ + "static/media/icon_artifact-size_small.6c6a1044.svg";